<template>
    <div class="loading-included">
        <div class="loading-text">
            <i class="fad fa-spinner fa-spin"></i> Chargement en cours...
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>
